export default {
  viewBox: "0 0 512 512",
  html: "<path d=\"M389 230c10 0 15 9 15 26s-5 26-15 26H282v107c0 10-9 15-26 15s-26-5-26-15V282H123c-10 0-15-9-15-26s5-26 15-26h107V123c0-10 9-15 26-15s26 5 26 15v107z\"/>"
};